// Core
import { 
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react';
import { TbCardsFilled, TbCards } from 'react-icons/tb';
import { PiUsersThreeFill, PiUsersThreeBold } from 'react-icons/pi';
import { TbEdit } from 'react-icons/tb';

// Components
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { textLang } from 'services/Lang';

const Row = ({ object, handleEditOpen, handleApprove }) => {
  const style = {
    borderRadius: '40px',
    background: 'white',
    padding: '16px',
    width: '64px',
    height: '64px',
    overflow: 'visible'
  };

  return (
    <Flex gap="10px" mb="16px" justifyContent="space-between">
      <Flex gap="8px" alignItems="center" w="50%">
        <Box position="relative" w="64px" h="64px">
          <Image src={object?.image}  borderRadius="16px" maxWidth="64px" w="100%" h="64px" objectFit="cover"  />
        </Box>
        <Box w="120px">
          <Text
            variant="title-md" 
            sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%', 
          }}
          >{object?.name}</Text>
          <Text
            variant="text-sm" 
            sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%', 
          }}
          >{textLang('approved_users')}: {object?.totalUsers || '0'}</Text>
        </Box>
      </Flex>

      <Flex gap="8px">
        <Box position="relative" style={style} onClick={() => {handleEditOpen(object);} }>
          <TbEdit fontSize="32px" />
        </Box>
        <Box onClick={() => handleApprove(object)} position="relative" style={style}>
          <PiUsersThreeBold fontSize="32px" />
          { object?.newUsers > 0 && (
            <Text 
              position="absolute" 
              top="0px" 
              left="0px"
              bg="#0088cd"
                color="white"
                w="21px"
                h="21px"
                p="1px 0 0 0"
                textAlign="center"
                borderRadius="full"
              position="absolute"
              >{object?.newUsers || 0}</Text>
          )}
        </Box>
      </Flex>
    </Flex>
  );
};

export default Row;